import { AnyProfile, FormFields, ProfileRole, Student } from '../../../types'

export const studentFields = ({
  state,
  userRole,
}: {
  state: AnyProfile
  userRole: ProfileRole | null
}): FormFields[] => {
  return [
    {
      title: 'Tipo de experiencia',
      rowRight: [
        {
          type: 'menu',
          label: 'experticeMenuStudent',
          id: 'experienceType',
          value: state.experienceType,
          userType: userRole === 'admin' ? userRole : state.role,
        },
      ],
    },
    {
      title: 'Tipo de actividad en Diga-ah!',
      rowRight: [
        {
          type: 'menu',
          label: 'activitiesStudent',
          id: 'activities',
          value: state.activities,
        },
      ],
    },
    {
      title: 'Elige a los tutores:',
      rowRight: [
        {
          type: 'menu',
          label: 'professorsNames',
          id: 'professors',
          value: (state as Student).professors,
        },
      ],
    },
    {
      title: 'Link de Dropbox-Grabaciones:',
      rowRight: [
        {
          type: 'link',
          label: 'Dropbox-Grabaciones',
          id: 'dropboxLink',
          value: (state as Student).dropboxLink ?? null,
          fullWidth: true,
          placeholder:
            (state as Student).dropboxLink || 'Pega el link a dropbox',
        },
      ],
    },
  ]
}
